export default (yearsAgo: number) => {
    const currentDate = new Date();
    currentDate.setFullYear(currentDate.getFullYear() - yearsAgo);
    return currentDate.getFullYear();
};
